module.exports = __webpack_public_path__ + "img/finland-infectious-diseases-female.8d62288f.png";